"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _Button = _interopRequireDefault(require("../Button"));
var _Image = _interopRequireWildcard(require("../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OAuthFailure = function OAuthFailure(_ref) {
  var message = _ref.message,
    onBack = _ref.onBack,
    onRetry = _ref.onRetry;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-24 px-32"
  }, /*#__PURE__*/_react["default"].createElement(Back, {
    onClick: onBack
  }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: "OnMail",
    className: "w-32",
    src: (0, _Image.withThemeSrc)(t('onmail.png'), t('onmail-light.png'))
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-6xl font-bold text-dark mb-5"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.oauthList.header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-8"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: t('error-dog.png'),
    className: "h-48",
    alt: "error-dog"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "retrofit.oauth.imap.denied"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-2xl font-bold text-dark"
  }))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-64 mt-16",
    onClick: onRetry
  }, t('button.retry')));
};
var Back = function Back(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "w-16 h-16 absolute mt-4 ml-4 top-0 left-0 shadow-lg flex items-center justify-center rounded-full cursor-pointer"
  }, props), /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null));
};
var _default = exports["default"] = OAuthFailure;
//# sourceMappingURL=OAuthFailure.js.map